import { render } from "./sourcesCreate.vue?vue&type=template&id=23c7c2e6"
const script = {}

import exportComponent from "/home/le01s/projects/amlogger/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__